module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('loading', {
    ref: "loading"
  }), _vm._v(" "), _c('warnBox', {
    ref: "warn_box"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c0297a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 235
// module chunks = 81